import * as React from "react";

export default function LicenseLinkCell(props) {
	
	const { dataItem } = props;
	
	const links = dataItem.licenses.map((license) => {
		if (license.licenseFile) 
			return (
				<p key={Math.random().toString(36).substr(2, 9)}>
					<a
						style={{
							textDecoration: "underline"
						}} 
						tabIndex="0" 
						href={window.location.origin + "/licenses/" + license.licenseFile}
					>
						{license.licenseType}
					</a>
				</p>
			);
		else if (license.licenseUrl)
			return (
				<p key={Math.random().toString(36).substr(2, 9)}>
					<a
						style={{
							textDecoration: "underline"
						}} 
						tabIndex="0" 
						target="_blank"
						href={license.licenseUrl}
					>
						{license.licenseType}
					</a>
				</p>
			);			
		else 
			return (
				<p key={Math.random().toString(36).substr(2, 9)}><span>{license.licenseType}</span></p>
			);
	});
   
  	return (
    	<td role="gridcell" aria-label="License Download Link">
			{links} 	
    	</td>
  	);
}